<template>
    <div class="content is-large">
        <h1>What is Hack Club?</h1>
        <p>Despite its name, Hack Club is actually a <b>coding club focused on building and creating</b>. Summer
            Creek High School and Woodcreek Middle School are part of an international Hack Club community that consists of hundreds of clubs!
            The Hack Club network also provides online student hackathons, coding tutorials, and AMAs with interesting people in tech.
        </p>
        <a href="https://hackclub.com/" class="button is-primary is-large" target="_blank">The Hack Club Network</a>
    </div>

</template>

<script>
    export default {
        name: "HackClub.vue",
    }
</script>

<style scoped>

</style>